import md5 from 'js-md5';
export default function useHash() {
    return md5;
}
